import Modal from "components/elements/Modal";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useCallback } from "react";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import QuestionResponseResource from "common/resources/Project/Config/Vote/QuestionResponseResource";
import QuestionService from "services/projects/QuestionService";
import { container } from "tsyringe";
import { useProjectId } from "hooks/useProjectId";

const questionService = container.resolve(QuestionService);

type IProps = {
	vote: QuestionResponseResource;
	onClose: () => void;
	onDelete: (vote: QuestionResponseResource) => void;
};

export default function DeleteVoteModal(props: IProps) {
	const { projectId } = useProjectId();
	const onDeleteVote = useCallback(() => {
		questionService
			.delete(projectId, props.vote.id)
			.then(() => {
				props.onDelete(props.vote);
			})
			.catch(console.error);
	}, [projectId, props]);

	return (
		<Modal isOpen onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.votes.delete_vote_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">{I18n.trslt(I18n.asset.pages.professional_space.tabs.votes.delete_vote_modal.text_1)}</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.votes.delete_vote_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.votes.delete_vote_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onDeleteVote}>
					{I18n.asset.pages.professional_space.tabs.votes.delete_vote_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
